import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=ec7883bc&scoped=true&"
import script from "./NoticeBar.vue?vue&type=script&lang=js&"
export * from "./NoticeBar.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=ec7883bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7883bc",
  null
  
)

export default component.exports